type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    id?: string | number;
};

export function TrophyIcon({ width = 24, height = 24, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.875 2C5.83947 2 5 2.83947 5 3.875V4H3C1.89543 4 1 4.89543 1 6V9C1 11.2091 2.79086 13 5 13H5.67363C6.62544 15.0036 8.50103 16.4833 10.75 16.8887V19.5H9.25C8.55964 19.5 8 20.0596 8 20.75C8 21.4404 8.55964 22 9.25 22H14.75C15.4404 22 16 21.4404 16 20.75C16 20.0596 15.4404 19.5 14.75 19.5H13.25V16.8887C15.499 16.4833 17.3746 15.0036 18.3264 13H19C21.2091 13 23 11.2091 23 9V6C23 4.89543 22.1046 4 21 4H19V3.875C19 2.83947 18.1605 2 17.125 2H6.875ZM20.5 9C20.5 9.82843 19.8284 10.5 19 10.5H18.9824C18.9941 10.3349 19 10.1681 19 10V6.5H20.5V9ZM5 10.5C4.17157 10.5 3.5 9.82843 3.5 9V6.5H5V10C5 10.1681 5.00593 10.3349 5.01758 10.5H5Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default TrophyIcon;
